import React from 'react'

import styled from 'styled-components'
const BREAKPOINTS = {
  desktop_large: 1680,
  desktop: 1072,
  laptop: 1024,
  tablet: 711,
  mobile: 0,
}

const BP = {
  MOBILE_LANDSCAPE: 542,
  TABLET_PORTRAIT: 712,
  TABLET_LANDSCAPE: 832,
  LAPTOP: 1024,
  DESKTOP: 1072,
  BREAKDANCE_1222: 1222,
  BREAKDANCE_1372: 1372,
  DESKTOP_LARGE: 1680,
  BREAKDANCE_1720: 1720,
  BREAKDANCE_1820: 1820,
  BREAKDANCE_1920: 1920,
}
const CONTENTWIDTH = {
  MOBILE_LANDSCAPE: 540,
  TABLET_PORTRAIT: 712,
  TABLET_LANDSCAPE: 784,
  LAPTOP: 968,
  DESKTOP: 1016,
  BREAKDANCE_1222: 1016,
  BREAKDANCE_1372: 1016,
  DESKTOP_LARGE: 1324,
  BREAKDANCE_1720: 1365,
  BREAKDANCE_1820: 1365,
  BREAKDANCE_1920: 1365,
}
const COLS = {
  MOBILE_LANDSCAPE: 8,
  TABLET_PORTRAIT: 8,
  TABLET_LANDSCAPE: 8,
  LAPTOP: 8,
  DESKTOP: 12,
  BREAKDANCE_1222: 12,
  BREAKDANCE_1372: 12,
  DESKTOP_LARGE: 12,
  BREAKDANCE_1720: 12,
  BREAKDANCE_1820: 12,
  BREAKDANCE_1920: 12,
}

export const Centered = styled.div`
  // Mobile
  display: grid;
  width: 100%;

  // MOBILE
  grid-template-columns: 1fr;

  // MOBILE LANDSCAPE
  @media only screen and (min-width: 541px) {
    grid-template-columns: 1fr ${CONTENTWIDTH.MOBILE_LANDSCAPE}px 1fr;
  }
  // MOBILE LANDSCAPE
  @media only screen and (min-width: 712px) {
    grid-template-columns: 0 1fr 0;
  }
  // TABLET LANDSCAPE
  @media only screen and (min-width: 832px) {
    grid-template-columns: auto ${CONTENTWIDTH.TABLET_LANDSCAPE}px auto;
  }
  // LAPTOP
  @media only screen and (min-width: 1024px) {
    grid-template-columns: auto ${CONTENTWIDTH.LAPTOP}px auto;
  }
  // DESKTOP
  @media only screen and (min-width: 1072px) {
    grid-template-columns: 1fr ${CONTENTWIDTH.DESKTOP}px 1fr;
  }
  // BREAKDANCE 1222
  @media only screen and (min-width: 1222px) {
    grid-template-columns: 1fr ${CONTENTWIDTH.BREAKDANCE_1222}px 0 1fr;
  }
  // BREAKDANCE 1372
  @media only screen and (min-width: 1372px) {
    grid-template-columns: 0 ${CONTENTWIDTH.BREAKDANCE_1372}px 300px 1fr;
    // Workaround negative margins on FrontEndComponent
    margin-left: calc((100vw - 1015px) / 2);
    margin-right: calc((100vw - 1015px) / 2);
  }
  // DESKTOP-LARGE
  @media only screen and (min-width: 1680px) {
    grid-template-columns: 0 ${CONTENTWIDTH.DESKTOP_LARGE}px 300px 1fr;
    // Workaround negative margins on FrontEndComponent
    margin-right: calc((100vw - 1323px) / 2);
    margin-left: calc((100vw - 1323px) / 2);
  }
  // BREAKDANCE 1720
  @media only screen and (min-width: 1720px) {
    grid-template-columns: 0 ${CONTENTWIDTH.BREAKDANCE_1720}px 300px 0;
    // Workaround negative margins on FrontEndComponent
    margin-right: calc((100vw - 1364px) / 2);
    margin-left: calc((100vw - 1364px) / 2);
  }
  // BREAKDANCE 1820
  @media only screen and (min-width: 1820px) {
    grid-template-columns: 0 ${CONTENTWIDTH.BREAKDANCE_1820}px 3fr 0;
    // Workaround negative margins on FrontEndComponent
    margin-right: calc((100vw - 1364px) / 2);
    margin-left: calc((100vw - 1364px) / 2);
  }
  // BREAKDANCE 1920
  @media only screen and (min-width: 1920px) {
    grid-template-columns: 1fr ${CONTENTWIDTH.BREAKDANCE_1920}px 1fr 0;
    // Workaround negative margins on FrontEndComponent
    margin-right: 0;
    margin-left: 0;
  }
`

export const _ContentGrid = styled.div<{ disableInnerGrid: boolean }>`
  display: ${(props) => (props.disableInnerGrid ? 'block' : 'grid')};
  position: relative;
  padding-left: 2rem;
  padding-right: 2rem;
  grid-column: 1;
  // TABLET PORTRAIT
  @media only screen and (min-width: 541px) {
    grid-column: 2;
    padding-left: 2.7rem;
    padding-right: 2.7rem;
  }
  // TABLET PORTRAIT
  @media only screen and (min-width: 712px) {
    padding-left: 2.4rem;
    padding-right: 2.4rem;
    display: grid;
    grid-gap: 0;
    column-gap: 2.4rem;
    grid-template-columns: repeat(8, 1fr);
  }
  // TABLET LANDSCAPE

  @media only screen and (min-width: 832px) {
    padding-left: 0;
    padding-right: 0;
  }
  // LAPTOP
  @media only screen and (min-width: 1024px) {
    column-gap: 2.8rem;
  }
  // DESKTOp
  @media only screen and (min-width: 1072px) {
    grid-template-columns: repeat(12, 1fr);
    padding-left: 0;
    padding-right: 0;
    column-gap: 2.8rem;
  }
  @media only screen and (min-width: 1222px) {
  }
  // DESKTOP LARGE
  @media only screen and (min-width: 1680px) {
    /* grid-column: 2; */
  }

  /* 
  @media only screen and (min-width: ${BREAKPOINTS.desktop}px) {
    padding-left: 2.8rem;
    padding-right: 2.8rem;
    grid-template-columns: repeat(12, 1fr);
    column-gap: 2.8rem;
  }  */
`
interface IContentGrid {
  disableInnerGrid?: boolean
  children?: string | JSX.Element | JSX.Element[]
}
export const ContentGrid: React.FC<IContentGrid> = ({
  children,
  disableInnerGrid = false,
}) => {
  return (
    <Centered className='Centered'>
      <_ContentGrid disableInnerGrid={disableInnerGrid} className='Grid'>
        {children && children}
      </_ContentGrid>
    </Centered>
  )
}
